/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type BudgetPageHeader_company = {
    readonly id: string;
    readonly tier: TierType | null;
    readonly currency: string | null;
    readonly sageIntacctConnectionEnabled: boolean | null;
    readonly " $refType": "BudgetPageHeader_company";
};
export type BudgetPageHeader_company$data = BudgetPageHeader_company;
export type BudgetPageHeader_company$key = {
    readonly " $data"?: BudgetPageHeader_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BudgetPageHeader_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetPageHeader_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctConnectionEnabled",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = 'ec2f01bcd93df906cd64a86024566654';
export default node;
